import { FC } from 'react';

import { sendAnalyticDownloadGuideClick } from 'services/analytics';

import { Text } from 'components/library';
import { Download } from 'components/Icon';

import * as S from './styled';

interface GuideProps {
  img?: string;
  link?: string;
  title: string;
}

const Guide: FC<GuideProps> = ({ title, img, link }) => {
  const handleDownloadClick = () => title && sendAnalyticDownloadGuideClick(title);

  return (
    <S.Container>
      {img && <S.GuideImg as="img" alt="guide-img" src={img} />}
      <S.GuideTitleContainer>
        <Text center={!img} type="medium-text">
          {title}
        </Text>
      </S.GuideTitleContainer>
      {link && (
        <a href={link} target="_blank" rel="noopener noreferrer" onClick={handleDownloadClick}>
          <Download />
        </a>
      )}
    </S.Container>
  );
};

export default Guide;
